import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { CommentListCollapse } from "../comment/CommentListCollapse";
import moment from "moment";
import { UserProfileInline } from "bf-library";
import { AlertMessage } from "app/components/AlertMessage";
import { LikeButton } from "app/components/LikeButton";
import { useMutation } from "@tanstack/react-query";
import { apiDeleteReadingPicture } from "./apiPicture";

export const ReadingPictureItem = ({ type = "picture", picture = null }) => {
    const { school } = useParams();
    const auth = useSelector((state) => state.auth);

    const isMyItem = useMemo(() => {
        return auth.authenticated && auth.id === picture.user?.id;
    }, [auth, picture]);

    //  ------------------- 삭제

    const deleteMutate = useMutation({
        mutationFn: apiDeleteReadingPicture,
        onSuccess: (res) => {
            picture.deleteYn = 'Y';
            picture.isApple = false;
        }
    });

    const onClickDelete = () => {
        if (deleteMutate.isPending) return;
        if (!auth.authenticated) return;
        if (picture.user?.id !== auth.id) {
            alert("삭제 권한이 없습니다.");
            return;
        }

        if (window.confirm("삭제하시겠습니까?")) {
            deleteMutate.mutate(picture.id);
        }
    }


    if (null === picture) return null;

    return (
        <div className={`readingActivityItem _${type} ${picture.deleteYn === "Y" ? "deleteContainer" : ""}`}>
            <div className="row">
                <AlertMessage type="delete" visible={picture.deleteYn === "Y"} />
                <div className="col3">
                    <div className={`book_wrap ${picture.bestYn === "Y" ? "best" : ""}`}>
                        {picture.bestYn !== "Y" && picture.goodYn === "Y" && (
                            <div className="stamp good _pc">
                                <img className="good" src={`${process.env.PUBLIC_URL}/images/common/good_stamp.png`} alt="참잘했어요" />
                            </div>
                        )}
                        {picture.bestYn === "Y" && (
                            <div className="stamp best _pc">
                                <img src={`${process.env.PUBLIC_URL}/images/common/best_stamp.png`} alt="참잘했어요" />
                            </div>
                        )}
                        <Link to={`/${school}/book/${picture.book.isbn}`}>
                            <div className="book_cover">
                                <div className="book_inner">
                                    <img src={picture.book?.image} alt={picture.title} />
                                    <div
                                        className={`service service_${picture.book.isService.toLowerCase()}`}
                                    ></div>
                                </div>
                            </div>
                        </Link>
                        <div className="book_info">
                            <p className="title">{picture.book.title}</p>
                            <p className="writer">{picture.book.author}</p>
                            <p className="pb_company">{picture.book.publisher}</p>
                            {picture.bestYn !== "Y" && picture.goodYn === "Y" && (
                                <div className="stamp good _mobile">
                                    <img className="good" src={`${process.env.PUBLIC_URL}/images/common/good_stamp.png`} alt="참잘했어요" />
                                </div>
                            )}
                            {picture.bestYn === "Y" && (
                                <div className="stamp best _mobile">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/common/best_stamp.png`}
                                        alt="참잘했어요"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col9">
                    <div className="title_area">
                        <div className="info_wrap">
                            <UserProfileInline id={picture.user?.id} name={picture.user?.name || picture.name}
                                image={picture.user?.image} type={picture.user?.type} school={picture.user?.schoolName}
                            >
                                <span className="fc-gray fs-12">({moment(picture.createdAt).format("YYYY.MM.DD")} 작성)</span>
                            </UserProfileInline>
                        </div>

                        {picture.deleteYn !== "Y" && (
                            <div className="btn_wrap">
                                <LikeButton type={type} activity={picture} />
                                {isMyItem && <button type="button" className="btn _xsm btn_delete" onClick={onClickDelete}>삭제</button>}
                            </div>
                        )}
                    </div>

                    <div className={`cont_area ${picture.bestYn === "Y" ? "best" : ""}`}>
                        <div className="cont_item">
                            <img src={`${process.env.PUBLIC_URL}/images/common/book_photo_item.png`} alt="" />
                        </div>
                        <div className="cont_wrap">
                            <div className="cont">
                                <img src={`${picture.image}`} alt={`${picture.user?.name}의 ${type === "photo" ? "독서사진" : "독서화"}`} />
                            </div>
                        </div>
                    </div>

                    <CommentListCollapse type={type} root={picture} readOnly={picture.deleteYn === "Y"} />
                </div>
            </div>
        </div>
    );
}; //end


